module.exports = __webpack_public_path__ + "static/media/check-mark-small.1dfee77c.svg";